import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import RegionForm from '../components/RegionForm';
import { useRegionDetails } from '../hooks/useRegionDetails';
import { useUpdateRegion } from '../hooks/useRegionMutations';
import type { RegionFormData } from '@/shared/types';

export default function RegionEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading: loadingDetails } = useRegionDetails(id);
  const mutation = useUpdateRegion();

  const handleSubmit = (formData: RegionFormData) => {
    mutation.mutate({ id: id!, data: formData }, { onSuccess: () => navigate('/regions') });
  };

  if (loadingDetails) return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', padding: 48 }} />;

  return (
    <div>
      <PageHeader back title={t('regions.edit')} subtitle={data?.nameEn} />
      <Card style={{ marginTop: 16 }}>
        <RegionForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
